import { Flex, Text, Box, Image } from "@chakra-ui/react"
import { ITableColumn } from "components/UI/organisms/Table/TableTypes"
import Icon from "components/UI/atoms/Icon"
import CarNumberBox from "components/UI/molecules/CarNumberBox"
import Price from "components/UI/atoms/Price"
import { ITransaction } from "types/transaction"

export const getColumns = (t: any): ITableColumn[] => [
  {
    key: "user",
    label: t("transactions.table.columns.user"),
    render: (data: ITransaction, isRowCollapsed) =>
      <Flex transform={`${isRowCollapsed ? "translateY(-1.25rem)" : ""}`}>
        <Flex gap={"10px"} >
          <Flex align={"center"} justifyContent="center" borderRadius={"50%"} h={"1.875rem"} w={"1.875rem"} bgColor="#E9F2FD" >
            <Icon
              name={"user"}
              iconStyles={{
                width: "0.938rem",
                height: "0.938rem",
                fill: "primary",
              }}
            />
          </Flex>
          <Text fontWeight="bold" fontSize={"base"}>{data?.userMobile}</Text>
        </Flex>
      </Flex>,
    hasClick: false,
  },
  {
    key: "carNumber",
    label: t("transactions.table.columns.vehicle"),
    render: (data: ITransaction, isRowCollapsed) => (
      <Flex alignItems="flex-start" transform={`${isRowCollapsed ? "translateY(-2.063rem)" : ""}`}>
        <CarNumberBox height="35px" width="150px" title={data?.vehicleGovNumber} />
      </Flex>
    ),
    hasClick: false,
  },
  {
    key: "laundryLogo",
    label: t("transactions.table.columns.laundry"),
    render: (data: ITransaction, isRowCollapsed) => (
      <Box transform={isRowCollapsed ? "translateY(-1.2rem)" : ""} display="grid">
        <Image src={data?.carWashLogo || ""} height="2.5rem"
          style={{ justifySelf: "center", alignSelf: "center" }} />
        <Text style={{ justifySelf: "center", alignSelf: "center" }}>{data?.carWash}</Text>
      </Box>
    ),
    hasClick: false,
  },
  {
    key: "price",
    label: t("transactions.table.columns.price"),
    render: (data: ITransaction, isRowCollapsed) => (
      <Price amount={data?.amount} transform={`${isRowCollapsed ? "translateY(-1.25rem)" : ""}`} />
    ),
    hasClick: false,
  },
  {
    key: "id",
    label: "#ID",
    render: (data: ITransaction, isRowCollapsed) => (
      <Text transform={`${isRowCollapsed ? "translateY(-1.25rem)" : ""}`}>{data?.bankTransactionId || "-"}</Text>
    )
  },
  {
    key: "status",
    label: t("transactions.table.columns.status"),
    render: (data: ITransaction, isRowCollapsed) => (
      <Box transform={isRowCollapsed ? "translateY(-0.2rem)" : ""}>
        <Image src={data.paymentStatusLogoUrl} />
      </Box>
    )
  }
]

